// BoardViewCompactButton.jsx

import React, { useState } from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './BoardViewCompactButton.css';

/**
 * BoardViewCompactButton
 * 
 * Renders a button for a node in the BoardViewCompact. Displays the node's 
 * title and handles click interactions.
 * 
 * @param {object} node - The node data to display in the button.
 * @param {function} onClick - Click handler function to invoke when the button is clicked.
 *  
 *
 * @returns {ReactNode} - BoardViewCompactButton.
 */
const BoardViewCompactButton = React.memo(({ node, onClick }) => {

    // ----- CONTEXT ----- //

    // Theme

    const { theme } = useTheme();

    // ----- STATE ----- //

    // Hover state

    const [isHovered, setIsHovered] = useState(false);

    // ----- RENDER ----- //

    return (

        <div
          className="board-view-compact-button-container"
          style={{
            backgroundColor: isHovered ? theme.backgroundHover : 'transparent',
          }}
          title={node?.title}
          onClick={onClick}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
            {node?.title}
        </div>
    );

});

// Dev Tools
BoardViewCompactButton.displayName = 'BoardViewCompactButton';

export default BoardViewCompactButton;
